var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520.5 205.1",
    style: {
      enableBackground: "new 0 0 520.5 205.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30613;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "440.2,94.4 440.2,82.9 461.4,82.9 461.4,72.8 440.2,72.8 440.2,62.4 467.4,62.4 467.4,52.4  429.1,52.4 429.1,104.4 468.1,104.4 468.1,94.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "405.7,104.4 405.7,94.4 381.5,94.4 381.5,52.4 370.3,52.4 370.3,104.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.8,51.3c-16,0-28.3,12.3-28.3,27.1c0,14.9,12.3,27.1,28.3,27.1c16,0,28.3-12.3,28.3-27.1 C345,63.5,332.8,51.3,316.8,51.3z M316.8,95.5c-9.3,0-16.7-7.4-16.7-17.1c0-9.7,7.4-17.1,16.7-17.1c9.3,0,16.7,7.4,16.7,17.1 C333.5,88.1,326.1,95.5,316.8,95.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.1,
    y: 52.4,
    className: "st0",
    width: 11.2,
    height: 52.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.3,51.3c-16,0-28.3,12.3-28.3,27.1s12.3,27.1,28.3,27.1c14.5,0,21.9-10.4,21.9-10.4l-6.7-7.1 c0,0-5.2,7.4-15.2,7.4c-9.7,0-17.1-7.4-17.1-17.1c0-9.7,7.4-17.1,17.1-17.1c9.7,0,14.5,7.4,14.5,7.4l7.1-7.1 C227.9,61.7,220.9,51.3,206.3,51.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.5,95.5c-6.3,0-11.5-5.2-11.5-12.3V52.4h-11.2v30.9c0,12.6,9.7,22.3,22.7,22.3s22.7-9.7,22.7-22.3V52.4 H142v30.9C142,90.3,136.8,95.5,130.5,95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.7,104.4 87.7,94.4 63.6,94.4 63.6,52.4 52.4,52.4 52.4,104.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.4,148.1c0,1.5-1.2,2.7-3.5,2.7c-3.1,0-4.5-2-4.5-2l-1.7,1.7c0,0,2,2.7,6.2,2.7c4,0,6.2-2.2,6.2-5.2 c0-6.5-9.2-4-9.2-8c0-1.1,1.1-2.2,3-2.2c2.4,0,3.5,1.5,3.5,1.5l1.7-1.7c0,0-1.7-2.2-5.2-2.2c-3.6,0-5.7,2.1-5.7,4.7 C342.2,146.6,351.4,144.1,351.4,148.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 135.6,
    className: "st0",
    width: 2.7,
    height: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,146.1c0,0,3.5-1.2,3.5-5.1c0-3-2.4-5.4-5.6-5.4h-7.4v17.5h2.7v-6.7h4l3.7,6.7h3L267.6,146.1z  M265.5,143.8h-4.6v-5.7h4.6c1.6,0,2.9,1.2,2.9,2.9S267.1,143.8,265.5,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.9,135.6h-2.7l-7.2,17.5h2.9l1.9-4.6h7.7l1.9,4.6h2.9L217.9,135.6z M213.7,146l2.9-7.2l2.9,7.2H213.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.6,135.6h-7v17.5h2.7v-6.2h4.2c3.4,0,5.9-2.5,5.9-5.6C177.5,138.1,175,135.6,171.6,135.6z M171.6,144.3 h-4.2v-6.2h4.2c1.7,0,3.1,1.4,3.1,3.1C174.8,143,173.4,144.3,171.6,144.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba16070cc35b5243b3a46a97eb00237b.svg";
export { ForwardRef as ReactComponent };